module.exports = __webpack_public_path__ + "img/features_scoretracker_phone_mobile2.a6ccebf8.jpg";